<template>
    <div style="display: flex;height: 60px;line-height: 60px;" >
        <div style=" display: flex; ">
            <div style="width: 45px; margin-left: 0;cursor: pointer">
                <img src="../assets/ds-logo01.png" alt="" style="width: 40px; height:40px; position: relative; top: 10px;" @click="$router.push('/')">
            </div>
            <span style="flex: 1; width:100px;text-align:right;font-size: 20px;cursor: pointer" @click="$router.push('/')">大神资源网</span>
        </div>
        <div>
            <div style="width: 800px">
                <el-menu :default-active="'1'" class="el-menu-demo" text-color="#12264f" active-text-color="#ee7959" mode="horizontal" router>
                    <el-menu-item index="/" >首页</el-menu-item>
                    <el-submenu index="2">
                        <template slot="title">AE资源</template>
                        <el-menu-item ><a href="/aeSoftware" >AE软件</a></el-menu-item>
                        <!--<el-menu-item @click="$router.push('/aePlug-in?pageNum=' + 1)">AE插件</el-menu-item>-->
                        <el-menu-item ><router-link to="/aePlug-in">AE插件</router-link></el-menu-item>
                        <el-menu-item ><router-link to="/aeScript">AE脚本</router-link></el-menu-item>
                        <el-menu-item ><router-link to="/aeTutorials">AE教程</router-link></el-menu-item>
                        <el-menu-item ><router-link to="/aeTemplate">AE模板</router-link></el-menu-item>
                    </el-submenu>
                    <el-submenu index="3">
                        <template slot="title">PR资源</template>
                        <!--<el-menu-item index="/prSoftware">PR软件</el-menu-item>-->
                        <!--<el-menu-item index="/prPlug-in">PR插件</el-menu-item>-->
                        <!--<el-menu-item index="/prScript">PR脚本</el-menu-item>-->
                        <!--<el-menu-item index="/prTutorials">PR教程</el-menu-item>-->
                        <!--<el-menu-item index="/prTemplate">PR模板</el-menu-item>-->
                        <el-menu-item ><router-link to="/prSoftware" >PR软件</router-link></el-menu-item>
                        <el-menu-item ><router-link to="/prPlug-in">PR插件</router-link></el-menu-item>
                        <el-menu-item ><router-link to="/prScript">PR脚本</router-link></el-menu-item>
                        <el-menu-item ><router-link to="/prTutorials">PR教程</router-link></el-menu-item>
                        <el-menu-item ><router-link to="/prTemplate">PR模板</router-link></el-menu-item>
                    </el-submenu>
                    <el-submenu index="4">
                        <template slot="title">3D资源</template>
                        <!--<el-menu-item index="/3dSoftware">3D软件</el-menu-item>-->
                        <!--<el-menu-item index="/3dPlug-in">3D插件</el-menu-item>-->
                        <!--<el-menu-item index="/3dTexture">3D贴图</el-menu-item>-->
                        <!--<el-menu-item index="/3dModel">3D模型</el-menu-item>-->
                        <!--<el-menu-item index="/3dTutorials">3D教程</el-menu-item>-->
                        <el-menu-item ><router-link to="/3dSoftware" >3D软件</router-link></el-menu-item>
                        <el-menu-item ><router-link to="/3dPlug-in">3D插件</router-link></el-menu-item>
                        <el-menu-item ><router-link to="/3dTexture">3D贴图</router-link></el-menu-item>
                        <el-menu-item ><router-link to="/3dModel">3D模型</router-link></el-menu-item>
                        <el-menu-item ><router-link to="/3dTutorials">3D教程</router-link></el-menu-item>
                        <!--<el-menu-item index="/3dProject">3D工程</el-menu-item>-->
                    </el-submenu>
                    <el-submenu index="5">
                        <template slot="title">其他资源</template>
                        <!--<el-menu-item index="/music-pack/">音效素材(合集)</el-menu-item>-->
                        <!--<el-menu-item ><a href="/music">音乐音效(单曲)</a></el-menu-item>-->
                        <!--<el-menu-item index="/vfx">特效素材</el-menu-item>-->
                        <!--<el-menu-item index="/front-video">视频背景</el-menu-item>-->
                        <!--<el-menu-item index="/frontBlog">站长博客</el-menu-item>-->
                        <!--<el-menu-item index="/other">其他资源</el-menu-item>-->
                        <!--<el-menu-item index="/introduction" disabled>站长简介</el-menu-item>-->
                        <el-menu-item ><router-link to="/music-pack">音效素材(合集)</router-link></el-menu-item>
                        <el-menu-item ><router-link to="/music">音乐音效(单曲)</router-link></el-menu-item>
                        <el-menu-item ><router-link to="/vfx">特效素材</router-link></el-menu-item>
                        <el-menu-item ><router-link to="/front-video">视频背景</router-link></el-menu-item>
                        <!--<el-menu-item ><router-link to="/frontBlog">站长博客</router-link></el-menu-item>-->
                        <el-menu-item ><router-link to="/other">其他资源</router-link></el-menu-item>
                        <el-menu-item index="/introduction" disabled>站长简介</el-menu-item>
                    </el-submenu>
                    <!--<el-menu-item index="/vip">VIP资源</el-menu-item>-->
                    <el-submenu index="/6">
                        <template slot="title">VIP资源</template>
                        <!--<el-menu-item index="/vip">VIP资源</el-menu-item>-->
                        <!--<el-menu-item ><a href="/vip">VIP资源</a></el-menu-item>-->
                        <el-menu-item ><router-link to="/vip">VIP资源</router-link></el-menu-item>

                        <el-menu-item ><a href="https://shop345832380.taobao.com/?spm=2013.1.1000126.d21.23372f70GelokD" target="_blank">前往淘宝</a></el-menu-item>
                        <el-menu-item ><a href="https://k.youshop10.com/okBuiEhT" target="_blank">前往微店</a></el-menu-item>
                        <!--<el-menu-item index="2-3" disabled>京东</el-menu-item>-->
                        <!--<el-menu-item index="2-4" disabled>拼多多</el-menu-item>-->
                    </el-submenu>
                    <!--<el-submenu index="6">-->
                        <!--<template slot="title" disabled>精品资源</template>-->
                        <!--<el-menu-item >暂无内容，敬请期待</el-menu-item>-->
                    <!--</el-submenu>-->
                    <el-menu-item index="/join">加入VIP</el-menu-item>
                    <!--<el-menu-item ><a href="/join">加入VIP</a></el-menu-item>-->

                    <el-menu-item index="7" disabled>消息中心</el-menu-item>
                </el-menu>
            </div>
        </div>
        <div style="margin-left:10px;margin-right:10px;width: 60px" >
            <el-button class="ml-5" type="primary" @click="search" >搜索</el-button>
        </div>
        <div style="width: 180px">
            <div v-if="!user.username" style="padding-right: 0">
                <el-button type="primary" @click="login">登录
                    <!--<router-link target="_blank" :to="'/login'"></router-link>-->
                </el-button>
                <el-button type="primary" @click="register">注册</el-button>
            </div>
            <div v-else>
                <el-dropdown style="width: 300px; text-align:center; cursor: pointer;">
                    <div style="display: inline-block">
                        <img :src="user.avatarUrl" @click="home" alt=""
                             style="width: 30px; border-radius: 50%; position: relative; top: 8px; right: 5px;">
                        <span @click="home">{{ user.nickname }}</span><i class="el-icon-arrow-down" style="margin-left: 5px"></i>
                    </div>
                    <el-dropdown-menu slot="dropdown" style="width: 200px">
                        <el-dropdown-item style="font-size: 14px; padding: 5px 0">
                            <!--<router-link to="/home">个人信息</router-link>-->
                            <span style="text-decoration: none" @click="home">个人信息</span>
                        </el-dropdown-item>
                        <!--<el-dropdown-item style="font-size: 14px; padding: 5px 0">-->
                            <!--<span style="text-decoration: none" @click="$router.push('/mobile')">切换手机版</span>-->
                            <!--&lt;!&ndash;<router-link to="/mobile">切换手机版</router-link>&ndash;&gt;-->
                        <!--</el-dropdown-item>-->
                        <el-dropdown-item style="font-size: 14px; padding: 5px 0">
                            <span style="text-decoration: none" @click="logout">退出</span>
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: "FrontHeader",
        data() {
            return {
                user: localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : {},

            }
        },
        methods: {
            login(){
                const routeUrl = this.$router.resolve("/login")
                window.open(routeUrl.href, '_blank');
            },
            register(){
                const routeUrl = this.$router.resolve("/register")
                window.open(routeUrl.href, '_blank');
            },

            search(){
                const routeUrl = this.$router.resolve("/search")
                window.open(routeUrl.href, '_blank');
            },

            home(){
                const routeUrl = this.$router.resolve("/home")
                window.open(routeUrl.href, '_blank');
            },
            logout() {
                this.$store.commit("logout");
                this.$message.success("退出成功")
            },
        }
    }
</script>

<style scoped>
    .Header {
        width: 100vw;
        height: 100vh;
    }
    .Header-box {
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
        /*width: 100vw;*/
        /*!*height: 100vh;*!*/
        display: flex;
        /*!*align-items: center;*!*/
        justify-content: center;
    }
    a {
        text-decoration: none;
        color:#1c1b1b;
        /*font-family:"阿里巴巴普惠体 Heavy";*/
        font-family:sans-serif;

        /*font-size: 18px;*/
    }
</style>